import { useState } from 'react';
import api from '../../../api';
import { logout } from '../../../api/custom/UserLogout';
import Button from '../../components/Button';
import ButtonContainer from '../../components/ButtonContainer';
import Modal from '../../components/Modal';
import triggerPopupAlert from '../../components/PopupAlert/trigger';
import { useAppContext } from '../../hooks/useAppContext';
import { goToUrl } from '../../services/Router';
import { getLoginUrl } from '../../services/User';

type Props = {
    onDismiss: () => void;
};

export function TwoFactorMigrationSpark({ onDismiss }: Props) {
    const { user } = useAppContext();
    const [isResetting, setIsResetting] = useState(false);

    const resetTwoFactor = async () => {
        setIsResetting(true);
        try {
            await api.users.resetTwoFactorVerification(user.id);
            return true;
        } catch {
            triggerPopupAlert('Something went wrong. Please try again.', 'error');
            return false;
        } finally {
            setIsResetting(false);
        }
    };

    const signOutAndSetUp = async () => {
        if (await resetTwoFactor()) {
            onDismiss();
            await logout();
            goToUrl(getLoginUrl());
        }
    };

    return (
        <Modal
            isOpen={true}
            title="Upgrade your security"
            size="MD_WIDTH"
            noCloseIcon={true}
            requireExplicitClose={true}
        >
            <p>
                You currently use your phone to receive two-factor login codes, but we are phasing out sms/phone codes.
                We recommend switching to an authenticator app (like Google Authenticator) for a faster, more secure
                login experience.
            </p>
            <ButtonContainer>
                <Button onClick={onDismiss} disabled={isResetting}>
                    Not now
                </Button>
                <Button kind="PRIMARY" onClick={signOutAndSetUp} disabled={isResetting}>
                    Sign out and configure Authenticator app
                </Button>
            </ButtonContainer>
        </Modal>
    );
}
